import { memo } from "react";

import HeaderPopover from "@/components/organisms/HeaderPopover";
import { LogoIcon } from "@/components/molecules/icons";
import { Box } from "@/components/atoms/Box";
import { Stack } from "@/components/atoms/Stack";
import { Icon } from "@/components/atoms/Icon";
import { Text } from "@/components/atoms/Text";

/**
 * Props for the TabViewHeaderView component
 */
interface Props {
  title: string;
  isDark: boolean;
  paddingTop: number;
  isCompact: boolean;
}

// design-system: dynamic-style waiver — safe-area top inset (measured, runtime)
const paddingTopStyle = (paddingTop: number) => ({ paddingTop });

/**
 * View component that renders a custom header with logo, title, and popover menu
 * @param root0 - Component props
 * @param root0.title - Title text to display in the header
 * @param root0.isDark - Boolean flag indicating if dark mode is active
 * @param root0.paddingTop - Amount to pad the header for safe area
 * @param root0.isCompact - Whether to use compact spacing for small screens
 */
const TabViewHeaderView = ({ title, isDark, paddingTop, isCompact }: Props) => (
  <Box
    // eslint-disable-next-line no-restricted-syntax -- safe-area top inset (measured, runtime); no closed spacing token
    UNSAFE_style={paddingTopStyle(paddingTop)}
    className={`${isCompact ? "pb-1" : "pb-2"} px-4`}
  >
    <Stack className={isCompact ? "gap-1" : "gap-5"}>
      <Stack direction="horizontal" className="items-center justify-between">
        <Icon as={LogoIcon} size="xl" />
        <HeaderPopover />
      </Stack>
      <Text
        variant={isCompact ? "display-sm" : "display-md"}
        className={`${isCompact ? "pb-micro" : "pb-1"} ${isDark ? "text-white" : "text-content-primary"}`}
      >
        {title}
      </Text>
    </Stack>
  </Box>
);

TabViewHeaderView.displayName = "TabViewHeaderView";

export default memo(TabViewHeaderView);
